import { AccountInterface, FeatureFlagKey, OrgInterface } from "@swivl-mono/types";

import { resolveFeatureFlag } from "./resolveFeatureFlag";

type AccountForFlag = Pick<AccountInterface, "kind"> | null | undefined;
type OrgForFlag = Pick<OrgInterface, "featureFlags"> | null | undefined;

// The engine switches the config tab is pointless without (ENG-3542). JIT lookup is left
// out on purpose: it only tunes how a fire reads its data.
const ENGINE_SWITCHES: readonly FeatureFlagKey[] = [
  FeatureFlagKey.BotSequenceEngineEnabled,
  FeatureFlagKey.BotSequenceEngineReconciler,
  FeatureFlagKey.BotSequenceEngineScheduler,
  FeatureFlagKey.BotSequenceEngineDispatcher
];

// Pure resolver for the Property Manager v3 Sequences tab and its routes: the
// `sequences_page` flag passes for this account (level honoured, like any UI flag) AND
// every engine switch above is present on the org (key present = on, level meaningless —
// docs/specs/new-sequence-approach/engine-gates.md). App code should call the app-bound
// `isSequencesConfigPageVisible()`; this is the primitive it wraps.
export function resolveSequencesConfigPageVisible(account: AccountForFlag, org: OrgForFlag): boolean {
  if (!resolveFeatureFlag(account, org, FeatureFlagKey.SequencesPage)) return false;
  const flags = org?.featureFlags;
  return ENGINE_SWITCHES.every((key) => flags?.[key] != null);
}
